const useDropdownSelect = props => {
  const {
    agGrid,
    dataSource,
    quickEdit,
    onDropdownOptionChanged,
    dropDownOptions,
    showDropDown
  } = props;

  const hidden = quickEdit.enabled || !dropDownOptions || !dropDownOptions.length || !showDropDown;
  const disabled = quickEdit.enabled;

  const optionOnClick = option => {
    onDropdownOptionChanged(option);
    dataSource.setOption(option);
    agGrid.setGridOption(dataSource, option);
  }

  return {
    hidden,
    disabled,
    dropDownOptions,
    optionOnClick
  }
}

export default useDropdownSelect;
